import React from "react";
import {
  StyledTopNav,
  Gradient,
  Content,
  TitleWrapper,
  SubTitle,
  Title
} from "./styles";
import FeedSearchbox from "./FeedSearchbox";

const TopNav = () => (
  <StyledTopNav>
    <Gradient />
    <Content>
      <TitleWrapper>
        <SubTitle>Powered by Samba</SubTitle>
        <Title>Admin Console</Title>
      </TitleWrapper>
      <FeedSearchbox />
    </Content>
  </StyledTopNav>
);

export default TopNav;
